<template>
  <gj-popover
    v-model="visible"
    placement="top"
    title="竞价调整"
    width="200"
    lazy
    trigger="manual"
    @show="popoverShow">
    <div class="gj-cell-display-switch" slot="reference" @click="showEdit()" v-if="isEdit">
      <i class="el-icon-edit"></i>
    </div>
    <el-form ref="form" :model="form">
      <el-form-item
        prop="percentage"
        :rules="[
          $gjReRule(RE.pt0, '请输入0~900整数值')
        ]">
        <gj-input v-model="form.percentage" width="200px" @input="valInput($event, 'percentage')">
          <template #append>%</template>
        </gj-input>
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin-top: 14px">
      <gj-button :size="'mini'" @click="close()">取消</gj-button>
      <gj-button :size="'mini'" type="primary" @click="confirm()" :loading="loading" >确定</gj-button>
    </div>
  </gj-popover>
</template>

<script>
  import { formRuleMixin } from "@/minxins";
export default {
  name: "ad-edit-bid-placement",
  mixins: [formRuleMixin],
  props: {
    value: {},
    isEdit: {
      type: Boolean,
      default: true
    },
    updateValue: {
        type: Function
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        percentage: null
      }
    };
  },
  components: {},
  methods: {
    valInput(val, type) {
        val > 900 && (this.form[type] = 900);
    },
    popoverShow() {
      this.form.percentage = this.value.percentage;
    },
    close() {
      this.visible = false
    },
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false;
        this.loading = true
        try {
          const data = await this.updateValue(this.form.percentage, this.value)
          this.visible = data
        } finally {
          this.loading = false
        }
      });
      
    },
    showEdit() {
      this.visible = true
    },
  },
};
</script>

<style scoped lang='scss'>
.el-icon-edit {
  font-size: 13px;
}
/deep/ .el-popover {
  padding: 16PX !important;
}
</style>